export const CONTACT_US_DATA = 'CONTACT_US_DATA';
export const CONTACT_US_SUCCESS = 'CONTACT_US_SUCCESS';
export const CONTACT_US_FAILURE = 'CONTACT_US_FAILURE';

export const CONTACT_REQUEST = 'CONTACT_REQUEST';
export const CONTACT_SUCCESS = 'CONTACT_SUCCESS';
export const CONTACT_FAILURE = 'CONTACT_FAILURE';
export const FETCH_INQUIRIES_REQUEST = 'FETCH_INQUIRIES_REQUEST';
export const FETCH_INQUIRIES_SUCCESS = 'FETCH_INQUIRIES_SUCCESS';
export const FETCH_INQUIRIES_FAILURE = 'FETCH_INQUIRIES_FAILURE';
export const MARK_INQUIRY_READ_SUCCESS = 'MARK_INQUIRY_READ_SUCCESS';
